(function () {
  'use strict';
  if (window.__PWW_V27_D__) return;
  window.__PWW_V27_D__ = true;

  var CFG = window.PWW_CFG;
  if (!CFG) return;

  var root = document.getElementById('pww-root');
  if (!root) return;

  var CHX = {
    'Deep Black':'#0f0f0f','Arctic White':'#f5f5f3','Atlantic Blue':'#3b6fb0','Moss Green':'#3f5340','New French Navy':'#1c2b5e','Bottle Green':'#234d32',
    'Burgundy':'#7b1e3a','Heather Grey':'#adb5bd','Solid Charcoal':'#3a3a3a','Airforce Blue':'#5a7fa0',
    'Khaki':'#a79b72','Fire Red':'#cc1010','Royal Blue':'#1f4fa3','Kelly Green':'#2e8b57',
    'Earthy Green':'#5c6b3e','Orange Crush':'#f57c00','Mocha Brown':'#7b5e52','Natural Stone':'#c9bda0',
    'Sapphire Blue':'#1e4d8c','Sun Yellow':'#ffd700','Dusty Lilac':'#b8a0c8','Solid Grey':'#6e7479',
    'Desert Sand':'#c2b08c','Cornflower Blue':'#7bb0d6','Cornflower blue':'#7bb0d6','Seafoam':'#9dcfba',
    'Dusty Green':'#7a8b70','DARK BLUE':'#162b4d','CAMEL':'#c19a6b','Stone Blue':'#6f8796',
    'Black':'#0f0f0f','White':'#f5f5f3','Navy':'#1e3a5f','Charcoal':'#3c3c3c','Royal':'#2851a3',
    'Dark Grey':'#444444','Purple':'#6b2fa0','Sapphire':'#1e4d8c','Sky Blue':'#87ceeb','Blue':'#3366cc',
    'Cornflower':'#6495ed','Silver':'#c0c0c0','Black Smoke':'#2a2a2a','Mid Blue':'#4f83b3',
    'Light Blue':'#7eb3e0','Soft White':'#f7f5ef','Grey':'#888888','Marl Grey':'#9c9c9c','Maroon':'#6d2b33',
    'Red':'#cc0000','Turquoise':'#40e0d0','Lilac':'#c3a9d8','Electric Orange':'#ff6f00',
    'Bright Royal':'#1f5bbf','Solid Navy':'#1e3a5f','Hot Pink':'#ff1493','Forest Green':'#2d6832',
    'Jade':'#00a86b','Navy Blue':'#1e3a5f','Heather Navy':'#58647a','Charcoal Grey':'#3c3c3c',
    'Pink':'#e91e8c','Baby Pink':'#f8bbd0','Natural':'#f0ede5','Sand':'#d2b48c','Stone':'#c2b49c',
    'Beige':'#f5f0dc','Cream':'#f5f0e0','Olive':'#6b7c45','Green':'#2d7a3a','Mint':'#98d4b5',
    'Light Pink':'#f8bbd0','Fuchsia':'#cc0066','Gold':'#d4a520','Mustard':'#c8962a','Brown':'#7d4a2a',
    'Mocha':'#967259','Chocolate':'#5c3317','Rust':'#b7410e','Teal':'#008080','Aqua':'#00ffff',
    'Cyan':'#00bcd4','Violet':'#8a2be2','Lavender':'#b094cc','Plum':'#6e3a5a','Wine':'#722f37',
    'Cherry Red':'#aa0020','Crimson':'#dc143c','Scarlet':'#ff2400','Sport Grey':'#a8a8a8','Ash Grey':'#b5b5b5',
    'Light Grey':'#cccccc','Dark Green':'#1a4a20','Forest':'#2d6832','Lime':'#8bc34a','Apple Green':'#4caf50',
    'Military Green':'#4a5e3a','Sage':'#8fad88','Off White':'#f5f2ec','Off-White':'#f5f2ec',
    'Ecru':'#f0ead6','Ivory':'#fffff0','Denim':'#1560bd','Steel Blue':'#4682b4','Midnight Blue':'#191970',
    'French Navy':'#172d5e','Oxford Navy':'#1c2e4a','Petrol':'#1b6b7b','Duck Egg':'#7fbfbf',
    'Cobalt Blue':'#0047ab','Powder Blue':'#b0d4e8','Baby Blue':'#a8d0e8','Light Green':'#7bc47f',
    'Hunter Green':'#355e3b','Emerald':'#2e8b4e','Light Red':'#e87070','Dark Red':'#8b0000',
    'Hot Coral':'#e86060','Coral':'#e8604a','Salmon':'#fa8072','Blush':'#f4a7b9','Rose':'#e8657a',
    'Pale Pink':'#f8d0da','Dusky Pink':'#c8928a','Dusty Pink':'#d8a0a0','Magenta':'#d81b8f',
    'Amber':'#ffbf00','Lemon Yellow':'#fff44f','Light Purple':'#9c67d4','Dark Purple':'#4a1a70',
    'Mauve':'#b78fa5','Light Brown':'#a07850','Dark Brown':'#4a2808','Coffee':'#6f4e37',
    'Walnut':'#6a4928','Chestnut':'#954535','Tan':'#d2a679',
    'Brick Red':'#8B3A3A','Jet Black':'#0a0a0a','Graphite':'#4a4a4a',
    'Antique Cherry Red':'#9b2335','Classic Olive':'#6b6b20','Electric Green':'#39ff14',
    'Fuchsia Pink':'#ff00aa','Hawaiian Blue':'#00a0e3','Deep Navy':'#0d1b3e',

  };

  function resolveHex(name){
    if(!name) return '#9ca3af';
    if(CHX[name]) return CHX[name];
    var key = String(name).replace(/\s+/g,' ').trim();
    if(CHX[key]) return CHX[key];
    var low = key.toLowerCase();
    for(var k in CHX){ if(k.toLowerCase()===low) return CHX[k]; }
    for(var k2 in CHX){ if(low.indexOf(k2.toLowerCase())>=0 || k2.toLowerCase().indexOf(low)>=0) return CHX[k2]; }
    return '#9ca3af';
  }
  function isLightHex(h){
    var x=(h||'#999').replace('#',''); if(x.length===3)x=x[0]+x[0]+x[1]+x[1]+x[2]+x[2];
    var r=parseInt(x.slice(0,2),16),g=parseInt(x.slice(2,4),16),b=parseInt(x.slice(4,6),16);
    return (r*299+g*587+b*114)/1000>180;
  }

  var ctx = String(CFG.productContext || '');
  var IS_HOOD = /\bhood(?:ie|ies|ed|y)?\b/i.test(ctx);
  var IS_ZIP = /\bzip(?:ped|per)?\b|\bzip[- ]?up\b/i.test(ctx);
  var NO_CENTRE_FRONT = IS_ZIP || /\b(softshell|body ?warmer|gilet|jacket|waistcoat)\b/i.test(ctx);
  var IS_SLEEVELESS = /\b(body ?warmer|gilet|waistcoat|sleeveless)\b/i.test(ctx);
  var IS_LOWER_BODY = /\b(trouser|trousers|short|shorts|jogger|joggers)\b/i.test(ctx);

  var colourOptIndex = CFG.options.findIndex(function (o) { return /colou?r/i.test(o.name); });
  var sizeOptIndex = CFG.options.findIndex(function (o) { return /^size$/i.test(o.name); });
  var COLOURS = colourOptIndex >= 0 ? CFG.options[colourOptIndex].vals.slice() : [];
  var SIZES = sizeOptIndex >= 0 ? CFG.options[sizeOptIndex].vals.slice() : ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];

  function variantColour(v) {
    if (colourOptIndex >= 0) return v.opts[colourOptIndex] || '';
    if (v.opts.length >= 2) return v.opts[0] || '';
    return '';
  }
  function variantSize(v) {
    if (sizeOptIndex >= 0) return v.opts[sizeOptIndex] || '';
    if (v.opts.length >= 2) return v.opts[1] || '';
    return v.opts[0] || '';
  }

  var VMAP = {};
  var STOCK = {};
  var PRICE = {};
  CFG.variants.forEach(function (v) {
    var cl = variantColour(v);
    var sz = variantSize(v);
    var tracked = v.mgmt === 'shopify';
    var avail = tracked ? v.qty > 0 : v.av;
    if (cl && sz) {
      if (!VMAP[cl]) VMAP[cl] = {};
      VMAP[cl][sz] = v.id;
      if (!STOCK[cl]) STOCK[cl] = {};
      STOCK[cl][sz] = { av: avail, qty: tracked ? v.qty : 9999 };
      if (!PRICE[cl]) PRICE[cl] = {};
      PRICE[cl][sz] = v.price;
    } else if (sz) {
      if (!VMAP['']) VMAP[''] = {};
      VMAP[''][sz] = v.id;
      if (!STOCK['']) STOCK[''] = {};
      STOCK[''][sz] = { av: avail, qty: tracked ? v.qty : 9999 };
      if (!PRICE['']) PRICE[''] = {};
      PRICE[''][sz] = v.price;
    }
  });

  function stockAvail(cl, sz) {
    var s = STOCK[cl] || STOCK[''];
    return !s || !s[sz] || s[sz].av;
  }

  var PR = {
    embroidery: {
      small: { p: CFG.prices.embroidery.small * 100, nm: 'Small', guide: 'Up to ~8cm — chest logo', dt: '£' + CFG.prices.embroidery.small },
      medium: { p: CFG.prices.embroidery.medium * 100, nm: 'Medium', guide: 'Up to ~15cm — sleeve / arm', dt: '£' + CFG.prices.embroidery.medium },
      large: { p: CFG.prices.embroidery.large * 100, nm: 'Large', guide: 'Up to ~30cm — front / back', dt: '£' + CFG.prices.embroidery.large }
    },
    dtf: {
      small: { p: CFG.prices.dtf.small * 100, nm: 'Small', guide: 'Palm-size chest logo', dt: '£' + CFG.prices.dtf.small },
      medium: { p: CFG.prices.dtf.medium * 100, nm: 'Medium', guide: 'Chest / sleeve print', dt: '£' + CFG.prices.dtf.medium },
      large: { p: CFG.prices.dtf.large * 100, nm: 'Large', guide: 'Full back / front print', dt: '£' + CFG.prices.dtf.large }
    }
  };
  var DIGI = {
    small: CFG.prices.digi.small * 100,
    medium: CFG.prices.digi.medium * 100,
    large: CFG.prices.digi.large * 100
  };
  var DIGI_FREE = CFG.prices.digiFree * 100;
  var HOOD_FLAT = CFG.prices.hood * 100;
  var GARMIN = CFG.garmentPrice;

  var DISCOUNTS = String(CFG.discounts || '')
    .replace(/\s+/g, '')
    .split(',')
    .map(function (t) {
      var p = t.split(':');
      return { min: parseInt(p[0], 10), pct: parseInt(p[1], 10) };
    })
    .filter(function (t) { return t.min > 0 && t.pct > 0; });

  var PL = [
    { id: 'flc', n: 'Front Left Chest', d: 'Your left as worn', badge: true, sz: { embroidery: ['small'], dtf: ['small'] }, rec: { method: 'embroidery', size: 'small' } },
    { id: 'frc', n: 'Front Right Chest', d: 'Your right as worn', sz: { embroidery: ['small'], dtf: ['small'] }, rec: { method: 'embroidery', size: 'small' } },
    { id: 'fc', n: 'Front Centre', d: 'Centred on the chest', sz: { embroidery: ['small', 'large'], dtf: ['small', 'medium', 'large'] } },
    { id: 'bk', n: 'Back', d: 'Upper or full back', badge: true, sz: { embroidery: ['small', 'large'], dtf: ['small', 'medium', 'large'] }, rec: { method: 'dtf', size: 'large' } },
    { id: 'ls', n: 'Left Sleeve', d: 'Upper left arm', sz: { embroidery: ['small', 'medium'], dtf: ['small', 'medium'] } },
    { id: 'rs', n: 'Right Sleeve', d: 'Upper right arm', sz: { embroidery: ['small', 'medium'], dtf: ['small', 'medium'] } },
    { id: 'hd', n: 'Hood', d: 'Hood panel', hood: true, sz: {} },
    { id: 'cx', n: 'Custom', d: 'Tell us exactly where', sz: { embroidery: ['small', 'large'], dtf: ['small', 'medium', 'large'] }, custom: true }
  ].filter(function (pl) {
    if (IS_LOWER_BODY && pl.id !== 'cx') return false;
    if (pl.id === 'fc' && NO_CENTRE_FRONT) return false;
    if ((pl.id === 'ls' || pl.id === 'rs') && IS_SLEEVELESS) return false;
    if (pl.id === 'hd' && !IS_HOOD) return false;
    return true;
  });

  var state = {
    step: 0,
    blank: false,
    colour: COLOURS[0] || '',
    qty: {}, // key colour|size -> number
    placements: {}, // id -> {method,size,where}
    files: [],
    labels: {},
    storedLogo: false,
    digiWaived: false
  };

  var els = {
    panels: root.querySelectorAll('[data-pww-panel]'),
    dots: root.querySelectorAll('[data-pww-step-dot]'),
    back: document.getElementById('pww-back'),
    next: document.getElementById('pww-next'),
    msg: document.getElementById('pww-msg'),
    colours: document.getElementById('pww-colours'),
    colourLabel: document.getElementById('pww-colour-label'),
    sizes: document.getElementById('pww-sizes'),
    qtyNote: document.getElementById('pww-qty-note'),
    places: document.getElementById('pww-places'),
    cfgs: document.getElementById('pww-cfgs'),
    files: document.getElementById('pww-files'),
    drop: document.getElementById('pww-drop'),
    fileInput: document.getElementById('pww-file'),
    summary: document.getElementById('pww-summary'),
    blankSwitch: document.getElementById('pww-blank-switch'),
    stored: document.getElementById('pww-stored'),
    name: document.getElementById('pww-name'),
    email: document.getElementById('pww-email'),
    notes: document.getElementById('pww-notes')
  };

  function fmt(p) { return '£' + (p / 100).toFixed(2); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function showMsg(t, ok) {
    els.msg.textContent = t || '';
    els.msg.className = 'pww-msg' + (t ? (ok ? ' is-ok' : ' is-err') : '');
  }
  function clearMsg() { showMsg(''); }

  function totalQty() {
    var t = 0;
    Object.keys(state.qty).forEach(function (k) { t += state.qty[k] || 0; });
    return t;
  }
  function qtyRows() {
    return Object.keys(state.qty).filter(function (k) { return state.qty[k] > 0; }).map(function (k) {
      var parts = k.split('|');
      var cl = parts[0], sz = parts[1];
      return (cl ? cl + ' ' : '') + sz + ' × ' + state.qty[k];
    });
  }
  function garmentSubtotal() {
    var sum = 0;
    Object.keys(state.qty).forEach(function (k) {
      var q = state.qty[k] || 0;
      if (!q) return;
      var parts = k.split('|');
      var cl = parts[0], sz = parts[1];
      var p = (PRICE[cl] && PRICE[cl][sz]) || (PRICE[''] && PRICE[''][sz]) || GARMIN;
      sum += p * q;
    });
    return sum;
  }
  function configuredPlacements() {
    return Object.keys(state.placements).filter(function (id) {
      var s = state.placements[id];
      return s && s.method;
    });
  }
  function calcDeco() {
    if (state.blank) return 0;
    var d = 0;
    configuredPlacements().forEach(function (id) {
      var s = state.placements[id];
      if (s.method === 'hood') d += HOOD_FLAT;
      else if (PR[s.method] && PR[s.method][s.size]) d += PR[s.method][s.size].p;
    });
    return d;
  }
  function calcDigitisationRaw() {
    if (state.blank) return 0;
    var max = 0;
    configuredPlacements().forEach(function (id) {
      var s = state.placements[id];
      if (s.method !== 'embroidery') return;
      max = Math.max(max, DIGI[s.size] || 0);
    });
    return max;
  }
  function getDiscount(qty) {
    var hit = null;
    DISCOUNTS.forEach(function (t) { if (qty >= t.min) hit = t; });
    return hit;
  }
  function estimate() {
    var q = totalQty();
    var deco = calcDeco();
    var digiRaw = state.digiWaived || state.storedLogo ? 0 : calcDigitisationRaw();
    var gSub = garmentSubtotal();
    var dSub = state.blank ? 0 : deco * q;
    var raw = gSub + dSub;
    var disc = getDiscount(q);
    var discAmt = disc ? Math.round(raw * disc.pct / 100) : 0;
    var digiCharged = (raw - discAmt >= DIGI_FREE) ? 0 : digiRaw;
    return {
      q: q,
      gSub: gSub,
      dSub: dSub,
      deco: deco,
      digiRaw: digiRaw,
      digiCharged: digiCharged,
      disc: disc,
      discAmt: discAmt,
      grand: raw - discAmt + digiCharged
    };
  }

  function renderColours() {
    if (!COLOURS.length) {
      els.colours.innerHTML = '<span class="pww-note">One colourway for this garment.</span>';
      state.colour = '';
      if (els.colourLabel) els.colourLabel.innerHTML = 'Colour: <span>Default</span>';
      return;
    }
    if (els.colourLabel) els.colourLabel.innerHTML = 'Colour: <span>' + esc(state.colour || COLOURS[0]) + '</span>';
    els.colours.innerHTML = COLOURS.map(function (c) {
      var hex = resolveHex(c);
      var on = c === state.colour ? ' is-on' : '';
      var light = isLightHex(hex) ? ' is-light' : '';
      return '<button type="button" class="pww-colour' + on + light + '" data-colour="' + esc(c) + '" title="' + esc(c) + '" aria-label="' + esc(c) + '" style="--swatch:' + hex + ';background:' + hex + '"><span class="pww-sr">' + esc(c) + '</span></button>';
    }).join('');
  }

  function renderSizes() {
    var cl = state.colour;
    els.sizes.innerHTML = SIZES.map(function (sz) {
      var key = cl + '|' + sz;
      var q = state.qty[key] || 0;
      var avail = stockAvail(cl, sz);
      var rowClass = 'pww-size-row' + (q ? '' : ' is-empty') + (avail ? '' : ' is-disabled');
      var dis = avail ? '' : ' disabled';
      return '<div class="' + rowClass + '">' +
        '<b>' + esc(sz) + '</b>' +
        '<div class="pww-qty">' +
        '<button type="button" data-qty-delta="-1" data-key="' + esc(key) + '"' + dis + ' aria-label="Decrease ' + esc(sz) + '">−</button>' +
        '<input type="number" min="0" inputmode="numeric" data-key="' + esc(key) + '" value="' + q + '"' + dis + ' aria-label="' + esc(sz) + ' quantity">' +
        '<button type="button" data-qty-delta="1" data-key="' + esc(key) + '"' + dis + ' aria-label="Increase ' + esc(sz) + '">+</button>' +
        '</div></div>';
    }).join('');
    var rows = qtyRows();
    els.qtyNote.textContent = totalQty() + ' garment' + (totalQty() === 1 ? '' : 's') +
      (rows.length ? ' · ' + rows.slice(0, 4).join(', ') + (rows.length > 4 ? '…' : '') : '');
  }

  function recHint(pl) {
    if (!pl || !pl.rec) return '';
    if (pl.rec.method === 'hood') return 'Recommended hood placement';
    var info = PR[pl.rec.method] && PR[pl.rec.method][pl.rec.size];
    var method = pl.rec.method === 'embroidery' ? 'embroidery' : 'DTF';
    return 'Recommended: ' + (info ? info.nm + ' ' : '') + method + (info && info.guide ? ' — ' + info.guide : '');
  }

  function sortedPlacements() {
    return PL.slice().sort(function (a, b) {
      return (b.badge ? 1 : 0) - (a.badge ? 1 : 0);
    });
  }

  function renderPlacements() {
    var imgs = CFG.placementImages || {};
    els.places.innerHTML = sortedPlacements().map(function (pl) {
      var on = state.placements[pl.id] ? ' is-on' : '';
      var rec = pl.badge ? ' is-rec' : '';
      var img = imgs[pl.id] ? '<img src="' + imgs[pl.id] + '" alt="">' : '<div class="pww-place-ph"></div>';
      var tag = pl.badge ? '<span class="pww-rec-tag">Popular</span>' : '';
      var hint = pl.rec ? '<span class="pww-rec-line">' + esc(recHint(pl)) + '</span>' : '';
      return '<button type="button" class="pww-place' + on + rec + '" data-place="' + pl.id + '">' +
        tag + '<span class="pww-check">✓</span>' + img +
        '<strong>' + esc(pl.n) + '</strong><span>' + esc(pl.d) + '</span>' + hint + '</button>';
    }).join('');
    renderCfgs();
  }

  function renderCfgs() {
    var ids = Object.keys(state.placements);
    if (!ids.length || state.blank) {
      els.cfgs.innerHTML = '';
      return;
    }
    els.cfgs.innerHTML = ids.map(function (id) {
      var pl = PL.find(function (p) { return p.id === id; });
      var s = state.placements[id] || {};
      if (pl.hood) {
        if (!s.method) s.method = 'hood';
        state.placements[id] = s;
        return '<div class="pww-cfg" data-cfg="' + id + '"><h5>' + esc(pl.n) + '</h5>' +
          '<p class="pww-cfg-rec">Flat fee · ' + fmt(HOOD_FLAT) + ' for hood text / print</p></div>';
      }
      var methods = Object.keys(pl.sz || {});
      if (!s.method && pl.rec) {
        s.method = pl.rec.method;
        s.size = pl.rec.size;
        state.placements[id] = s;
      }
      var methodBtns = methods.map(function (m) {
        var isRec = pl.rec && pl.rec.method === m;
        return '<button type="button" data-cfg-method="' + m + '" class="' + (s.method === m ? 'is-on' : '') + (isRec ? ' is-rec' : '') + '">' +
          (m === 'embroidery' ? 'Embroidery' : 'DTF print') +
          (isRec ? '<small>Recommended</small>' : '') + '</button>';
      }).join('');
      var sizes = (s.method && pl.sz[s.method]) ? pl.sz[s.method] : [];
      if (s.method && sizes.length && sizes.indexOf(s.size) < 0) {
        s.size = (pl.rec && pl.rec.method === s.method && sizes.indexOf(pl.rec.size) >= 0) ? pl.rec.size : sizes[0];
        state.placements[id] = s;
      }
      var sizeBtns = sizes.map(function (sz) {
        var info = PR[s.method][sz];
        var isRec = pl.rec && pl.rec.method === s.method && pl.rec.size === sz;
        return '<button type="button" data-cfg-size="' + sz + '" class="' + (s.size === sz ? 'is-on' : '') + (isRec ? ' is-rec' : '') + '">' +
          info.nm + ' · ' + info.dt +
          '<small>' + (isRec ? 'Recommended · ' : '') + esc(info.guide || '') + '</small></button>';
      }).join('');
      var custom = pl.custom
        ? '<div class="pww-field" style="margin-top:8px"><label>Describe position</label>' +
          '<input type="text" data-cfg-where value="' + esc(s.where || '') + '" placeholder="e.g. above left pocket"></div>'
        : '';
      var recLine = pl.rec ? '<p class="pww-cfg-rec">' + esc(recHint(pl)) + '</p>' : '';
      return '<div class="pww-cfg" data-cfg="' + id + '"><h5>' + esc(pl.n) + '</h5>' + recLine +
        '<span class="pww-cfg-label">Decoration method</span>' +
        '<div class="pww-seg" data-seg="method">' + methodBtns + '</div>' +
        (sizeBtns ? '<span class="pww-cfg-label">Print / stitch size</span><div class="pww-seg" data-seg="size">' + sizeBtns + '</div>' : '') +
        custom + '</div>';
    }).join('');
  }

  function updateDropUI() {
    var title = document.getElementById('pww-drop-title');
    var sub = document.getElementById('pww-drop-sub');
    var btn = root.querySelector('.pww-drop-btn');
    var n = state.files.length;
    if (els.drop) els.drop.classList.toggle('is-filled', n > 0);
    if (title) title.textContent = n ? (n + ' logo' + (n === 1 ? '' : 's') + ' attached') : 'Add your logo';
    if (sub) sub.textContent = n
      ? 'These files stay on your order for our team. Add another if you need to.'
      : 'PNG, SVG, PDF, AI, EPS or JPG · transparent PNG / vector preferred';
    if (btn) btn.textContent = n ? 'Add another file' : 'Choose files';
  }

  function revokePreviews() {
    (state.previews || []).forEach(function (u) { try { URL.revokeObjectURL(u); } catch (e) {} });
    state.previews = [];
  }

  function renderFiles() {
    updateDropUI();
    revokePreviews();
    if (!state.files.length) {
      els.files.innerHTML = '';
      return;
    }
    state.previews = [];
    els.files.innerHTML = state.files.map(function (f, i) {
      var thumb;
      if (f.type && f.type.indexOf('image/') === 0) {
        var url = URL.createObjectURL(f);
        state.previews.push(url);
        thumb = '<div class="pww-file__thumb"><img src="' + url + '" alt=""></div>';
      } else {
        var ext = (f.name.split('.').pop() || 'FILE').toUpperCase().slice(0, 4);
        thumb = '<div class="pww-file__thumb">' + esc(ext) + '</div>';
      }
      return '<div class="pww-file" data-file="' + i + '">' + thumb + '<div><b>' + esc(f.name) + '</b>' +
        '<input type="text" data-file-label placeholder="Where is this used? e.g. left chest" value="' + esc(state.labels[i] || '') + '"></div>' +
        '<button type="button" data-file-remove aria-label="Remove">×</button></div>';
    }).join('');
  }

  function decoLinesText() {
    if (state.blank) return 'BLANK GARMENTS — No decoration';
    return configuredPlacements().map(function (id) {
      var pl = PL.find(function (p) { return p.id === id; });
      var s = state.placements[id];
      var where = s.where ? ' (' + s.where + ')' : '';
      if (s.method === 'hood') return pl.n + where + ': Hood · ' + fmt(HOOD_FLAT);
      var info = PR[s.method][s.size];
      return pl.n + where + ': ' + (s.method === 'embroidery' ? 'Embroidery' : 'DTF') + ' · ' + info.nm + ' (' + info.dt + ')';
    }).join(' | ');
  }

  function renderSummary() {
    var e = estimate();
    var rows = [
      ['Garments', e.q + (e.q ? ' · ' + qtyRows().join(', ') : '')],
      ['Decoration', state.blank ? 'Blank — none' : (configuredPlacements().length ? decoLinesText() : 'None yet')],
      ['Garment subtotal', fmt(e.gSub)],
      ['Decoration subtotal', e.dSub ? fmt(e.dSub) : '£0.00'],
      ['Bulk discount', e.discAmt ? e.disc.pct + '% (−' + fmt(e.discAmt) + ')' : 'None'],
      ['Digitisation', e.digiCharged ? fmt(e.digiCharged) + ' one-off' : (calcDigitisationRaw() ? 'Waived / free' : 'N/A')],
      ['Artwork', state.files.length ? state.files.map(function (f) { return f.name; }).join(', ') : (state.storedLogo ? 'On file at Printora' : 'None')],
      ['Estimated total', fmt(e.grand)]
    ];
    els.summary.innerHTML = '<dl>' + rows.map(function (r, i) {
      return '<div' + (i === rows.length - 1 ? ' class="pww-total"' : '') + '><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>';
    }).join('') + '</dl>';
  }

  function setStep(n) {
    state.step = n;
    els.panels.forEach(function (p) {
      p.classList.toggle('is-active', Number(p.getAttribute('data-pww-panel')) === n);
    });
    els.dots.forEach(function (d) {
      var i = Number(d.getAttribute('data-pww-step-dot'));
      d.classList.toggle('is-on', i === n);
      d.classList.toggle('is-done', i < n);
    });
    els.back.hidden = n === 0;
    els.next.textContent = n === 3 ? 'Add order to basket' : 'Continue';
    if (n === 1) renderPlacements();
    if (n === 2) renderFiles();
    if (n === 3) renderSummary();
    clearMsg();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function validateStep(n) {
    if (n === 0) {
      if (totalQty() < 1) return 'Add at least one size quantity.';
      return '';
    }
    if (n === 1 && !state.blank) {
      if (!configuredPlacements().length) return 'Choose at least one logo placement, or turn on blank garments.';
      var bad = configuredPlacements().find(function (id) {
        var pl = PL.find(function (p) { return p.id === id; });
        var s = state.placements[id];
        if (pl.hood) return false;
        if (!s.method || !s.size) return true;
        if (pl.custom && !(s.where || '').trim()) return true;
        return false;
      });
      if (bad) return 'Finish decoration options for each selected placement.';
      return '';
    }
    if (n === 2) {
      var name = (els.name.value || '').trim();
      var email = (els.email.value || '').trim();
      els.name.classList.toggle('err', !name);
      els.email.classList.toggle('err', !email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
      if (!name || !email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return 'Enter your name and a valid email.';
      if (!state.blank && !state.files.length && !state.storedLogo) {
        return 'Upload your logo, or tick that Printora already has it on file.';
      }
      return '';
    }
    return '';
  }

  async function addToCart() {
    var err = validateStep(2);
    if (err) { showMsg(err); setStep(2); return; }
    if (totalQty() < 1) { showMsg('Add garment quantities first.'); setStep(0); return; }
    if (!state.blank && !configuredPlacements().length) { showMsg('Choose placements or blank garments.'); setStep(1); return; }

    els.next.disabled = true;
    els.next.textContent = 'Adding…';
    clearMsg();

    var e = estimate();
    var artworkRef = 'WW-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 7).toUpperCase();
    var custName = els.name.value.trim();
    var custEmail = els.email.value.trim();
    var fileInfo = state.files.length
      ? state.files.map(function (f, i) { return f.name + (state.labels[i] ? ' [' + state.labels[i] + ']' : ''); }).join(', ')
      : 'Printora already has this logo on file';

    // Primary variant = first colour/size with qty (basket shows ONE garment line)
    var primaryVid = CFG.vid;
    var firstKey = Object.keys(state.qty).find(function (k) { return state.qty[k] > 0; });
    if (firstKey) {
      var fp = firstKey.split('|');
      primaryVid = (VMAP[fp[0]] && VMAP[fp[0]][fp[1]]) || (VMAP[''] && VMAP[''][fp[1]]) || CFG.vid;
    }

    var props = {
      'Artwork Reference': artworkRef,
      'Workwear Bundle': 'Yes — single order line',
      'Logo Artwork': fileInfo,
      'Artwork Status': state.files.length ? 'Uploaded with basket' : 'Printora has file on record',
      'Decoration Details': decoLinesText(),
      'Sizes / Quantities': qtyRows().join(' | '),
      '_Customer Name': custName,
      '_Customer Email': custEmail,
      '_Total Garments': String(e.q),
      '_Deco Per Garment': fmt(e.deco),
      '_Bulk Discount': e.discAmt ? e.disc.pct + '% (−' + fmt(e.discAmt) + ')' : 'None',
      '_Digitisation Fee': e.digiCharged ? fmt(e.digiCharged) + ' (one-off)' : (state.storedLogo ? 'Waived — on file' : (e.digiRaw ? 'FREE – order qualified' : 'N/A')),
      '_Estimated Total': fmt(e.grand),
      '_Instructions': (els.notes.value || '').trim() || 'None',
      '_Fulfillment Note': 'Fulfil from Sizes / Quantities breakdown (may span colours/sizes).'
    };

    try {
      var uploadForm = new FormData();
      uploadForm.append('id', primaryVid);
      uploadForm.append('quantity', e.q);
      Object.keys(props).forEach(function (k) {
        uploadForm.append('properties[' + k + ']', props[k]);
      });
      state.files.forEach(function (f, i) {
        var label = (state.labels[i] || ('Logo ' + (i + 1))).replace(/[^\w\s\-.]/g, ' ').trim();
        uploadForm.append('properties[Logo File ' + (i + 1) + ']', f, f.name);
        uploadForm.append('properties[Logo File ' + (i + 1) + ' Label]', label);
      });
      if (state.files.length) {
        uploadForm.append('properties[Artwork Files]', 'Open each Logo File link on this order line in Shopify Admin');
      }

      var primaryResponse = await fetch('/cart/add.js', {
        method: 'POST',
        body: uploadForm,
        headers: { Accept: 'application/json' }
      });
      if (!primaryResponse.ok) {
        var primaryError = 'Could not add workwear order';
        try {
          var pj = await primaryResponse.json();
          if (pj && pj.description) primaryError += ': ' + pj.description;
        } catch (ignore) {}
        throw new Error(primaryError);
      }

      // Decoration + digitisation fee SKUs (same Artwork Reference — grouped in cart UI)
      var feeItems = [];
      if (!state.blank && e.q > 0) {
        configuredPlacements().forEach(function (id) {
          var pl = PL.find(function (p) { return p.id === id; });
          var s = state.placements[id];
          var key = s.method === 'hood' ? 'hood' : s.method + ':' + s.size;
          var svcVid = CFG.svc[key];
          if (svcVid) {
            feeItems.push({
              id: svcVid,
              quantity: e.q,
              properties: {
                'Decoration Placement': pl.n + (s.where ? ' (' + s.where + ')' : ''),
                'Artwork Reference': artworkRef,
                '_Customer': custName,
                '_Bundled With': 'Workwear order ' + artworkRef
              }
            });
          }
        });
      }
      if (e.digiCharged > 0) {
        var digiKey = 'digi:small';
        configuredPlacements().forEach(function (id) {
          var s = state.placements[id];
          if (s.method === 'embroidery') {
            if (s.size === 'large') digiKey = 'digi:large';
            else if (s.size === 'medium' && digiKey !== 'digi:large') digiKey = 'digi:medium';
          }
        });
        if (CFG.svc[digiKey]) {
          feeItems.push({
            id: CFG.svc[digiKey],
            quantity: 1,
            properties: {
              'Artwork Reference': artworkRef,
              '_Customer': custName,
              '_Note': 'One-off embroidery artwork setup fee',
              '_Bundled With': 'Workwear order ' + artworkRef
            }
          });
        }
      }

      if (feeItems.length) {
        var cr = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: feeItems })
        });
        if (!cr.ok) {
          var cartError = 'Decoration fees could not be added';
          try {
            var cj = await cr.json();
            if (cj && cj.description) cartError += ': ' + cj.description;
          } catch (ignore2) {}
          throw new Error(cartError);
        }
      }

      var cartAttrs = {
        'Workwear Customer': custName + ' (' + custEmail + ')',
        'Workwear Decoration': decoLinesText(),
        'Artwork Reference': artworkRef,
        'Logo Files': fileInfo,
        'Artwork Status': state.files.length ? 'Uploaded with basket — see Logo File links on main line' : 'Printora has file on record',
        'Sizes / Quantities': qtyRows().join(' | ')
      };
      if (e.disc) cartAttrs['Bulk Discount Owed'] = e.disc.pct + '% = ' + fmt(e.discAmt) + ' off — apply at checkout';
      var updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: cartAttrs })
      });
      if (!updateResponse.ok) throw new Error('Could not save order details to basket');

      // Notify Formspree for staff (best effort)
      try {
        if (CFG.formspree) {
          var fd = new FormData();
          fd.append('email', custEmail);
          fd.append('name', custName);
          fd.append('subject', 'Workwear order ' + artworkRef);
          fd.append('message', [
            'Artwork Reference: ' + artworkRef,
            'Product: ' + CFG.productTitle,
            'Sizes: ' + qtyRows().join(', '),
            'Decoration: ' + decoLinesText(),
            'Artwork: ' + fileInfo,
            'Estimated: ' + fmt(e.grand),
            'Notes: ' + ((els.notes.value || '').trim() || 'None')
          ].join('\n'));
          fetch(CFG.formspree, { method: 'POST', body: fd, headers: { Accept: 'application/json' } }).catch(function () {});
        }
      } catch (ignore3) {}

      if (e.disc) window.location.href = '/discount/WORKWEAR-' + e.disc.pct + 'PCT?redirect=/cart';
      else window.location.href = '/cart';
    } catch (ex) {
      showMsg(ex.message || 'Something went wrong. Please try again or email orders@printora.co.uk.');
      els.next.disabled = false;
      els.next.textContent = 'Add order to basket';
    }
  }

  // Events
  els.blankSwitch.addEventListener('click', function () {
    state.blank = !state.blank;
    els.blankSwitch.classList.toggle('is-on', state.blank);
    els.blankSwitch.setAttribute('aria-checked', state.blank ? 'true' : 'false');
    if (state.blank) {
      state.placements = {};
      renderPlacements();
    }
    var panel1 = root.querySelector('[data-pww-panel="1"]');
    if (panel1) panel1.style.opacity = state.blank ? '0.45' : '1';
  });

  els.colours.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-colour]');
    if (!btn) return;
    state.colour = btn.getAttribute('data-colour');
    renderColours();
    renderSizes();
  });

  els.sizes.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-qty-delta]');
    if (!btn) return;
    var key = btn.getAttribute('data-key');
    var delta = parseInt(btn.getAttribute('data-qty-delta'), 10);
    state.qty[key] = Math.max(0, (state.qty[key] || 0) + delta);
    renderSizes();
  });
  els.sizes.addEventListener('change', function (ev) {
    var inp = ev.target.closest('input[data-key]');
    if (!inp) return;
    state.qty[inp.getAttribute('data-key')] = Math.max(0, parseInt(inp.value, 10) || 0);
    renderSizes();
  });

  els.places.addEventListener('click', function (ev) {
    if (state.blank) {
      showMsg('Turn off blank garments to add decoration.');
      return;
    }
    var btn = ev.target.closest('[data-place]');
    if (!btn) return;
    var id = btn.getAttribute('data-place');
    if (state.placements[id]) delete state.placements[id];
    else state.placements[id] = {};
    renderPlacements();
  });

  els.cfgs.addEventListener('click', function (ev) {
    var cfg = ev.target.closest('[data-cfg]');
    if (!cfg) return;
    var id = cfg.getAttribute('data-cfg');
    var s = state.placements[id] || {};
    var mBtn = ev.target.closest('[data-cfg-method]');
    var sBtn = ev.target.closest('[data-cfg-size]');
    if (mBtn) {
      s.method = mBtn.getAttribute('data-cfg-method');
      s.size = undefined;
      state.placements[id] = s;
      renderCfgs();
    } else if (sBtn) {
      s.size = sBtn.getAttribute('data-cfg-size');
      state.placements[id] = s;
      renderCfgs();
    }
  });
  els.cfgs.addEventListener('input', function (ev) {
    var inp = ev.target.closest('[data-cfg-where]');
    if (!inp) return;
    var cfg = ev.target.closest('[data-cfg]');
    var id = cfg.getAttribute('data-cfg');
    state.placements[id] = state.placements[id] || {};
    state.placements[id].where = inp.value;
  });

  function addFiles(list) {
    var added = 0;
    Array.prototype.forEach.call(list || [], function (f) {
      if (!f) return;
      // Skip duplicates by name+size
      var dup = state.files.some(function (x) { return x.name === f.name && x.size === f.size; });
      if (dup) return;
      state.files.push(f);
      added++;
    });
    renderFiles();
    if (added) showMsg(added + ' file' + (added === 1 ? '' : 's') + ' added to your order.', true);
    else if (list && list.length) showMsg('That file is already attached.', false);
  }
  // Reliable file picking (label button + change delegation — works after modal portal)
  root.addEventListener('change', function (ev) {
    var input = ev.target && ev.target.id === 'pww-file' ? ev.target : null;
    if (!input) return;
    addFiles(input.files);
    try { input.value = ''; } catch (e) {}
  });
  if (els.drop) {
    ['dragenter', 'dragover'].forEach(function (evt) {
      els.drop.addEventListener(evt, function (e) {
        e.preventDefault();
        e.stopPropagation();
        els.drop.classList.add('is-over');
      });
    });
    ['dragleave', 'drop'].forEach(function (evt) {
      els.drop.addEventListener(evt, function (e) {
        e.preventDefault();
        e.stopPropagation();
        els.drop.classList.remove('is-over');
        if (evt === 'drop' && e.dataTransfer) addFiles(e.dataTransfer.files);
      });
    });
  }
  els.files.addEventListener('click', function (ev) {
    var rm = ev.target.closest('[data-file-remove]');
    if (!rm) return;
    var row = ev.target.closest('[data-file]');
    var i = Number(row.getAttribute('data-file'));
    state.files.splice(i, 1);
    var nextLabels = {};
    Object.keys(state.labels).forEach(function (k) {
      var n = Number(k);
      if (n < i) nextLabels[n] = state.labels[n];
      else if (n > i) nextLabels[n - 1] = state.labels[n];
    });
    state.labels = nextLabels;
    renderFiles();
  });
  els.files.addEventListener('input', function (ev) {
    var inp = ev.target.closest('[data-file-label]');
    if (!inp) return;
    var row = ev.target.closest('[data-file]');
    state.labels[Number(row.getAttribute('data-file'))] = inp.value;
  });
  els.stored.addEventListener('change', function () {
    state.storedLogo = !!els.stored.checked;
    state.digiWaived = state.storedLogo;
  });

  els.back.addEventListener('click', function () {
    if (state.step > 0) setStep(state.step - 1);
  });
  els.next.addEventListener('click', function () {
    if (state.step < 3) {
      var err = validateStep(state.step);
      if (err) { showMsg(err); return; }
      var next = state.step + 1;
      if (state.blank && next === 1) next = 2; // skip placements when blank
      setStep(next);
      return;
    }
    addToCart();
  });

  function bootUI(){
    renderColours();
    renderSizes();
    renderPlacements();
    renderFiles();
    setStep(state.step || 0);
  }
  bootUI();
  window.PWW_REFRESH = bootUI;
})();
